import {
  FETCH_ACCOUNT_BALANCES,
  FETCH_ACCOUNT_BALANCES_SUCCESS,
  FETCH_ACCOUNT_BALANCES_FAILURE,
  FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES,
  FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES_SUCCESS,
  FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES_FAILURE,
  SELECT_SL_ACCOUNTS,
} from './types';

import { FETCHING_SL_GROUPS_INITIAL_DATA_SUCCESS } from '../../aggregationMenu/store/types';

const initialState = {
  accountBalances: [],
  slAccounts: [],
  selectedSlAccounts: [],
  accountBalancesLoading: false,
  slAccountsLoading: false,
};

function accountBalancesReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ACCOUNT_BALANCES:
      return {
        ...state,
        accountBalancesLoading: true,
      };
    case FETCH_ACCOUNT_BALANCES_SUCCESS:
      return {
        ...state,
        accountBalances: action.accountBalances,
        accountBalancesLoading: false,
      };
    case FETCH_ACCOUNT_BALANCES_FAILURE:
      return {
        ...state,
        accountBalancesLoading: false,
      };
    case FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES:
      return {
        ...state,
        slAccountsLoading: true,
      };
    case FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES_SUCCESS:
      return {
        ...state,
        slAccounts: action.slAccounts,
        slAccountsLoading: false,
      };
    case FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES_FAILURE:
      return {
        ...state,
        slAccountsLoading: false,
      };
    case SELECT_SL_ACCOUNTS:
      return {
        ...state,
        selectedSlAccounts: action.selectedSlAccounts,
      };
    case FETCHING_SL_GROUPS_INITIAL_DATA_SUCCESS:
      return {
        ...state,
        selectedSlAccounts: initialState.selectedSlAccounts,
      };
    default:
      return {
        ...state,
      };
  }
}

export default accountBalancesReducer;
